module.exports = __webpack_public_path__ + "img/zcash.f26bd4c4.png";